<script lang="ts" setup>
import { Story } from '@/models/story.model';
import { ShiftCMSState } from '@/store';
import { StoriesState } from '@/stores/stories.store';
import { computed, defineProps } from 'vue';
import { useStore } from 'vuex';

const store = useStore<ShiftCMSState & { ts: StoriesState }>();
const story = computed<Story | null>(() => store.state.ts.story);

const props = defineProps({
  item: {
    type: String,
  },
});
</script>
<template>
  <v-app-bar app>
    <v-breadcrumbs
      :items="[
        { title: 'Stories', to: '/stories' },
        props.item ? props.item : story ? `${story.title}` : 'List',
      ]"
    />
  </v-app-bar>
</template>
<style>
.v-toolbar {
  z-index: 100 !important;
}
</style>
